import React from "react";

const NotificationIcon = () => (
  <svg
    width="36"
    height="36"
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="36" height="36" rx="18" fill="#EEEFF0" />
    <path
      d="M24.8253 19.7173L23.8837 18.1507C23.6753 17.809 23.492 17.1507 23.492 16.7507V15.1923C23.492 12.1673 21.0337 9.70898 18.017 9.70898C14.992 9.71732 12.5337 12.1673 12.5337 15.1923V16.7423C12.5337 17.1423 12.3503 17.8007 12.1503 18.1423L11.2087 19.709C10.8503 20.3173 10.767 21.009 10.992 21.609C11.217 22.2173 11.7253 22.7007 12.392 22.9173C13.292 23.2173 14.2003 23.434 15.1253 23.5923C15.217 23.609 15.3087 23.6173 15.4003 23.634C15.517 23.6507 15.642 23.6673 15.767 23.684C15.9837 23.7173 16.2003 23.7423 16.4253 23.759C16.9503 23.809 17.4837 23.834 18.017 23.834C18.542 23.834 19.067 23.809 19.5837 23.759C19.7753 23.7423 19.967 23.7257 20.1503 23.7007C20.3003 23.684 20.4503 23.6673 20.6003 23.6423C20.692 23.634 20.7837 23.6173 20.8753 23.6007C21.8087 23.4507 22.7337 23.2173 23.6337 22.9173C24.2753 22.7007 24.767 22.2173 25.0003 21.6007C25.2337 20.9757 25.167 20.2923 24.8253 19.7173ZM18.6253 16.334C18.6253 16.684 18.342 16.9673 17.992 16.9673C17.642 16.9673 17.3587 16.684 17.3587 16.334V13.7507C17.3587 13.4007 17.642 13.1173 17.992 13.1173C18.342 13.1173 18.6253 13.4007 18.6253 13.7507V16.334Z"
      fill="#292D32"
    />
    <path
      d="M20.3587 24.6743C20.0087 25.641 19.0837 26.3327 18.0004 26.3327C17.3421 26.3327 16.6921 26.066 16.2337 25.591C15.9671 25.341 15.7671 25.0077 15.6504 24.666C15.7587 24.6827 15.8671 24.691 15.9837 24.7077C16.1754 24.7327 16.3754 24.7577 16.5754 24.7743C17.0504 24.816 17.5337 24.841 18.0171 24.841C18.4921 24.841 18.9671 24.816 19.4337 24.7743C19.6087 24.7577 19.7837 24.7493 19.9504 24.7243C20.0837 24.7077 20.2171 24.691 20.3587 24.6743Z"
      fill="#292D32"
    />
  </svg>
);

const SecureHomeIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.51602 2.36713L3.02435 5.86713C2.27435 6.45046 1.66602 7.69213 1.66602 8.63379V14.8088C1.66602 16.7421 3.24102 18.3255 5.17435 18.3255H14.8244C16.7577 18.3255 18.3327 16.7421 18.3327 14.8171V8.75046C18.3327 7.74213 17.6577 6.45046 16.8327 5.87546L11.6827 2.26713C10.516 1.45046 8.64102 1.49213 7.51602 2.36713Z"
      stroke="#006216"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.75 15H11.25C12.625 15 13.75 13.875 13.75 12.5V10C13.75 8.625 12.625 7.5 11.25 7.5H8.75C7.375 7.5 6.25 8.625 6.25 10V12.5C6.25 13.875 7.375 15 8.75 15Z"
      stroke="#006216"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10 7.5V15"
      stroke="#006216"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.25 11.25H13.75"
      stroke="#292D32"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const CalendarIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.66602 1.66602V4.16602"
      stroke="#4D5154"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.334 1.66602V4.16602"
      stroke="#4D5154"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.91602 7.57422H17.0827"
      stroke="#292D32"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.5 7.08268V14.166C17.5 16.666 16.25 18.3327 13.3333 18.3327H6.66667C3.75 18.3327 2.5 16.666 2.5 14.166V7.08268C2.5 4.58268 3.75 2.91602 6.66667 2.91602H13.3333C16.25 2.91602 17.5 4.58268 17.5 7.08268Z"
      stroke="#292D32"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.99607 11.4167H10.0036"
      stroke="#292D32"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.91209 11.4167H6.91957"
      stroke="#292D32"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.91209 13.9167H6.91957"
      stroke="#292D32"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const UsersGroupIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.0004 5.96602C14.9504 5.95769 14.8921 5.95769 14.8421 5.96602C13.6921 5.92435 12.7754 4.98268 12.7754 3.81602C12.7754 2.62435 13.7337 1.66602 14.9254 1.66602C16.1171 1.66602 17.0754 2.63268 17.0754 3.81602C17.0671 4.98268 16.1504 5.92435 15.0004 5.96602Z"
      stroke="#4D5154"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.1422 12.0328C15.2839 12.2245 16.5422 12.0245 17.4255 11.4328C18.6005 10.6495 18.6005 9.36615 17.4255 8.58282C16.5339 7.99115 15.2589 7.79115 14.1172 7.99115"
      stroke="#4D5154"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.97344 5.96602C5.02344 5.95769 5.08177 5.95769 5.13177 5.96602C6.28177 5.92435 7.19844 4.98268 7.19844 3.81602C7.19844 2.62435 6.24011 1.66602 5.04844 1.66602C3.85677 1.66602 2.89844 2.63268 2.89844 3.81602C2.90677 4.98268 3.82344 5.92435 4.97344 5.96602Z"
      stroke="#292D32"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.83255 12.0328C4.69088 12.2245 3.43255 12.0245 2.54922 11.4328C1.37422 10.6495 1.37422 9.36615 2.54922 8.58282C3.44089 7.99115 4.71588 7.79115 5.85755 7.99115"
      stroke="#292D32"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.0004 12.1926C9.95039 12.1842 9.89206 12.1842 9.84206 12.1926C8.69206 12.1509 7.77539 11.2092 7.77539 10.0426C7.77539 8.85091 8.73372 7.89258 9.92539 7.89258C11.1171 7.89258 12.0754 8.85925 12.0754 10.0426C12.0671 11.2092 11.1504 12.1592 10.0004 12.1926Z"
      stroke="#292D32"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.57461 14.8168C6.39961 15.6001 6.39961 16.8835 7.57461 17.6668C8.90794 18.5585 11.0913 18.5585 12.4246 17.6668C13.5996 16.8835 13.5996 15.6001 12.4246 14.8168C11.0996 13.9335 8.90794 13.9335 7.57461 14.8168Z"
      stroke="#292D32"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const SecureCameraIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.66602 9.16732V7.50065C1.66602 4.58398 3.33268 3.33398 5.83268 3.33398H14.166C16.666 3.33398 18.3327 4.58398 18.3327 7.50065V12.5007C18.3327 15.4173 16.666 16.6673 14.166 16.6673H9.99935"
      stroke="#4D5154"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.99935 12.0827C11.1499 12.0827 12.0827 11.1499 12.0827 9.99935C12.0827 8.84876 11.1499 7.91602 9.99935 7.91602C8.84876 7.91602 7.91602 8.84876 7.91602 9.99935C7.91602 11.1499 8.84876 12.0827 9.99935 12.0827Z"
      stroke="#4D5154"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.416 7.91602V12.0827"
      stroke="#292D32"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1.66602 12.918H6.11604C6.64937 12.918 7.08268 13.3513 7.08268 13.8846V14.9513"
      stroke="#292D32"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.68266 11.9004L1.66602 12.917L2.68266 13.9337"
      stroke="#292D32"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.08268 17.3165H2.63266C2.09933 17.3165 1.66602 16.8832 1.66602 16.3498V15.2832"
      stroke="#292D32"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.06641 18.3341L7.08305 17.3175L6.06641 16.3008"
      stroke="#292D32"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const UserProfileCircleIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.1009 10.6497C10.0426 10.6414 9.96758 10.6414 9.90091 10.6497C8.43424 10.5997 7.26758 9.39974 7.26758 7.92474C7.26758 6.41641 8.48424 5.19141 10.0009 5.19141C11.5092 5.19141 12.7342 6.41641 12.7342 7.92474C12.7259 9.39974 11.5676 10.5997 10.1009 10.6497Z"
      stroke="#4D5154"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.6161 16.1508C14.1328 17.5091 12.1661 18.3341 9.99948 18.3341C7.83281 18.3341 5.86615 17.5091 4.38281 16.1508C4.46615 15.3674 4.96615 14.6008 5.85781 14.0008C8.14115 12.4841 11.8745 12.4841 14.1411 14.0008C15.0328 14.6008 15.5328 15.3674 15.6161 16.1508Z"
      stroke="#4D5154"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.99935 18.3327C14.6017 18.3327 18.3327 14.6017 18.3327 9.99935C18.3327 5.39698 14.6017 1.66602 9.99935 1.66602C5.39698 1.66602 1.66602 5.39698 1.66602 9.99935C1.66602 14.6017 5.39698 18.3327 9.99935 18.3327Z"
      stroke="#292D32"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const BellNotificationIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10 5.36719V8.14219"
      stroke="#4D5154"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
    <path
      d="M10.0171 1.66602C6.9504 1.66602 4.46707 4.14935 4.46707 7.21601V8.96602C4.46707 9.53268 4.23374 10.3827 3.94207 10.866L2.88374 12.6327C2.23374 13.7243 2.68374 14.941 3.88374 15.341C7.86707 16.666 12.1754 16.666 16.1587 15.341C17.2837 14.966 17.7671 13.6493 17.1587 12.6327L16.1004 10.866C15.8087 10.3827 15.5754 9.52435 15.5754 8.96602V7.21601C15.5671 4.16602 13.0671 1.66602 10.0171 1.66602Z"
      stroke="#4D5154"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
    <path
      d="M12.7746 15.6836C12.7746 17.2086 11.5246 18.4586 9.99961 18.4586C9.24128 18.4586 8.54128 18.1419 8.04128 17.6419C7.54128 17.1419 7.22461 16.4419 7.22461 15.6836"
      stroke="#292D32"
      strokeWidth="1.5"
      strokeMiterlimit="10"
    />
  </svg>
);

const BookOpenQuestionIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15 15.7174H14.3667C13.7 15.7174 13.0667 15.9758 12.6 16.4424L11.175 17.8508C10.525 18.4925 9.46667 18.4925 8.81667 17.8508L7.39166 16.4424C6.925 15.9758 6.28333 15.7174 5.625 15.7174H5C3.61667 15.7174 2.5 14.6091 2.5 13.2425V4.15076C2.5 2.78409 3.61667 1.67578 5 1.67578H15C16.3833 1.67578 17.5 2.78409 17.5 4.15076V13.2425C17.5 14.6008 16.3833 15.7174 15 15.7174Z"
      stroke="#4D5154"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.83398 7.633C5.83398 6.858 6.46732 6.22461 7.24232 6.22461C8.01732 6.22461 8.65066 6.858 8.65066 7.633C8.65066 9.19966 6.42565 9.36633 5.93398 10.858C5.83398 11.1663 6.09232 11.4747 6.41732 11.4747H8.65066"
      stroke="#4D5154"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.3674 11.4661V6.70777C13.3674 6.4911 13.2258 6.29939 13.0174 6.24105C12.8091 6.18272 12.5841 6.26605 12.4675 6.44939C11.8675 7.41605 11.2174 8.51606 10.6508 9.48273C10.5591 9.64106 10.5591 9.8494 10.6508 10.0077C10.7424 10.1661 10.9175 10.266 11.1091 10.266H14.1674"
      stroke="#292D32"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const ArrowRightRedIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.627 9.74732L13.3336 8.04065L11.627 6.33398"
      stroke="#D42620"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.50586 8.03906H13.2859"
      stroke="#D42620"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.83919 13.3327C4.89253 13.3327 2.50586 11.3327 2.50586 7.99935C2.50586 4.66602 4.89253 2.66602 7.83919 2.66602"
      stroke="#D42620"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const LockShieldIcon = () => (
  <svg
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21.5891 6.97953C20.7391 6.03953 19.3291 5.56953 17.2591 5.56953H17.0191V5.52953C17.0191 3.84953 17.0191 1.76953 13.2591 1.76953H11.7391C7.97906 1.76953 7.97906 3.84953 7.97906 5.52953V5.56953H7.73906C5.66906 5.56953 4.24906 6.03953 3.40906 6.97953C2.41906 8.08953 2.44906 9.55953 2.54906 10.5695L2.55906 10.6395L2.62814 11.4455C2.64134 11.5994 2.72488 11.7387 2.8546 11.8227C3.13829 12.0063 3.44012 12.199 3.72906 12.3595C3.86906 12.4495 4.01906 12.5295 4.16906 12.6095C5.29906 13.2295 6.50906 13.7195 7.74906 14.0595C7.77906 16.6495 9.89906 18.7495 12.4991 18.7495C15.1191 18.7495 17.2491 16.6195 17.2491 13.9995V13.9595C18.5091 13.5795 19.7191 13.0495 20.8491 12.3895C20.9091 12.3595 20.9491 12.3295 20.9991 12.2995C21.3937 12.0851 21.803 11.8043 22.1766 11.5395C22.2929 11.457 22.3678 11.3285 22.3832 11.1868L22.4491 10.5795C22.4591 10.5195 22.4591 10.4695 22.4691 10.3995C22.5491 9.39953 22.5291 8.01953 21.5891 6.97953Z"
      fill="#C8CCD0"
    />
    <path
      d="M9.40906 5.52953C9.40906 3.82953 9.40906 3.18953 11.7391 3.18953H13.2591C15.5891 3.18953 15.5891 3.82953 15.5891 5.52953V5.56953H9.40906V5.52953Z"
      fill="#C8CCD0"
    />
    <path
      d="M12.4991 17.2495C10.8491 17.2495 9.47906 16.0095 9.27906 14.4095C9.25906 14.2795 9.24906 14.1395 9.24906 13.9995C9.24906 12.2095 10.7091 10.7495 12.4991 10.7495C14.2891 10.7495 15.7491 12.2095 15.7491 13.9995C15.7491 14.1195 15.7391 14.2295 15.7291 14.3395V14.3495C15.5491 15.9795 14.1691 17.2495 12.4991 17.2495Z"
      fill="#C8CCD0"
    />
    <path
      d="M11.9309 16.0303C11.7409 16.0303 11.5509 15.9603 11.4009 15.8103L10.4109 14.8303C10.1209 14.5403 10.1209 14.0603 10.4109 13.7703C10.7009 13.4803 11.1809 13.4803 11.4709 13.7703L11.9509 14.2503L13.5609 12.7703C13.8609 12.4903 14.3409 12.5103 14.6209 12.8103C14.9009 13.1103 14.8809 13.5903 14.5809 13.8703L12.4509 15.8403C12.2909 15.9603 12.1109 16.0303 11.9309 16.0303Z"
      fill="#C8CCD0"
    />
    <path
      d="M21.5416 13.7311C21.7903 13.5929 22.1129 13.7931 22.087 14.0765L21.7316 17.9611C21.5216 19.9611 20.7016 22.0011 16.3016 22.0011H8.68156C4.28156 22.0011 3.46156 19.9611 3.26156 17.9711L2.91569 14.2678C2.88884 13.9802 3.19635 13.786 3.45156 13.9211C4.23156 14.3511 5.04156 14.7311 5.87156 15.0311C6.18156 15.1411 6.40156 15.4011 6.49156 15.7211C7.24156 18.3211 9.66156 20.2511 12.5016 20.2511C15.3916 20.2511 17.8316 18.2811 18.5416 15.5811C18.6216 15.2611 18.8416 15.0011 19.1516 14.8811C19.9916 14.5511 20.7916 14.1611 21.5416 13.7311Z"
      fill="#C8CCD0"
    />
  </svg>
);

const CashIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.82906 6.63953C5.25906 4.46953 6.86906 3.51953 9.10906 3.51953H17.8891C20.5291 3.51953 22.2891 4.83953 22.2891 7.91953V13.0695C22.2891 15.2895 21.3791 16.5895 19.8791 17.1495C19.6591 17.2295 19.4191 17.2995 19.1691 17.3395C18.7691 17.4295 18.3391 17.4695 17.8891 17.4695H9.09906C6.45906 17.4695 4.69906 16.1495 4.69906 13.0695V7.91953C4.69906 7.44953 4.73906 7.02953 4.82906 6.63953ZM18.4691 11.9995C18.4691 12.4095 18.8091 12.7495 19.2191 12.7495C19.6291 12.7495 19.9691 12.4095 19.9691 11.9995V8.99953C19.9691 8.58953 19.6291 8.24953 19.2191 8.24953C18.8091 8.24953 18.4691 8.58953 18.4691 8.99953V11.9995ZM13.4991 13.1395C14.9591 13.1395 16.1391 11.9595 16.1391 10.4995C16.1391 9.03953 14.9591 7.85953 13.4991 7.85953C12.0391 7.85953 10.8591 9.03953 10.8591 10.4995C10.8591 11.9595 12.0391 13.1395 13.4991 13.1395ZM7.03906 11.9995C7.03906 12.4095 7.37906 12.7495 7.78906 12.7495C8.19906 12.7495 8.53906 12.4095 8.53906 11.9995V8.99953C8.53906 8.58953 8.19906 8.24953 7.78906 8.24953C7.37906 8.24953 7.03906 8.58953 7.03906 8.99953V11.9995Z"
      fill="#003B0D"
    />
    <path
      d="M1.70023 10.9203V16.0703C1.70023 19.1503 3.46023 20.4803 6.11023 20.4803H14.8902C15.6402 20.4803 16.3102 20.3703 16.8902 20.1503C17.3602 19.9803 17.7702 19.7303 18.1002 19.4103C18.2802 19.2403 18.1402 18.9703 17.8902 18.9703H9.11023C5.41023 18.9703 3.21023 16.7703 3.21023 13.0803V7.92028C3.21023 7.68028 2.94023 7.53028 2.77023 7.71028C2.09023 8.43028 1.70023 9.48028 1.70023 10.9203Z"
      fill="#292D32"
    />
  </svg>
);

const NotificationBellIcon = () => (
  <svg
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.5 2C18.02 2 22.5 6.48 22.5 12C22.5 17.52 18.02 22 12.5 22C6.98 22 2.5 17.52 2.5 12C2.5 6.48 6.98 2 12.5 2ZM17.65 9.44C17.23 8.47 16.44 7.72 15.35 7.38V6.58C15.35 6.17 15.01 5.83 14.6 5.83C14.19 5.83 13.85 6.17 13.85 6.58V7.17H11.14V6.58C11.14 6.17 10.8 5.83 10.39 5.83C9.98 5.83 9.64 6.17 9.64 6.58V7.37C8.55 7.71 7.76 8.46 7.34 9.43C7.2 9.76 7.44 10.14 7.8 10.14H17.19C17.55 10.14 17.79 9.77 17.65 9.44ZM7 14.17C7 16.37 8.5 18.17 11 18.17H14C16.5 18.17 18 16.37 18 14.17V11.64C18 11.36 17.78 11.14 17.5 11.14H7.5C7.22 11.14 7 11.36 7 11.64V14.17Z"
      fill="#003B0D"
    />
  </svg>
);

const SendIcon = () => (
  <svg
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="28" height="28" rx="14" fill="#EEEFF0" />
    <path
      d="M16.2987 11.3748L10.099 10.1398L10.4246 8.50552L19.4144 10.2963L17.6237 19.2861L15.9893 18.9606L17.2243 12.7608L8.7889 18.3939L7.86333 17.0078L16.2987 11.3748Z"
      fill="#006216"
    />
  </svg>
);

const ClockIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.6673 8.00065C14.6673 11.6807 11.6807 14.6673 8.00065 14.6673C4.32065 14.6673 1.33398 11.6807 1.33398 8.00065C1.33398 4.32065 4.32065 1.33398 8.00065 1.33398C11.6807 1.33398 14.6673 4.32065 14.6673 8.00065Z"
      stroke="#464749"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.4739 10.1192L8.40724 8.88586C8.04724 8.67253 7.75391 8.15919 7.75391 7.73919V5.00586"
      stroke="#464749"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const ShieldCheckIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.41379 5.66065C3.72712 -0.112681 12.2805 -0.106014 13.5871 5.66732C14.3538 9.05399 12.2471 11.9207 10.4005 13.694C9.06046 14.9873 6.94046 14.9873 5.59379 13.694C3.75379 11.9207 1.64712 9.04732 2.41379 5.66065Z"
      stroke="#464749"
    />
    <path
      d="M6.16602 7.66667L7.16602 8.66667L9.83268 6"
      stroke="#464749"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const SearchIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.33398 13.334C10.6477 13.334 13.334 10.6477 13.334 7.33398C13.334 4.02028 10.6477 1.33398 7.33398 1.33398C4.02028 1.33398 1.33398 4.02028 1.33398 7.33398C1.33398 10.6477 4.02028 13.334 7.33398 13.334Z"
      stroke="#B4B8BB"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.6196 13.7939C12.973 14.8605 13.7796 14.9672 14.3996 14.0339C14.9663 13.1805 14.593 12.4805 13.5663 12.4805C12.8063 12.4739 12.3796 13.0672 12.6196 13.7939Z"
      stroke="#B4B8BB"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const SearchZoomIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11 20C15.9706 20 20 15.9706 20 11C20 6.02944 15.9706 2 11 2C6.02944 2 2 6.02944 2 11C2 15.9706 6.02944 20 11 20Z"
      stroke="#292D32"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.9304 20.6888C19.4604 22.2888 20.6704 22.4488 21.6004 21.0488C22.4504 19.7688 21.8904 18.7188 20.3504 18.7188C19.2104 18.7088 18.5704 19.5988 18.9304 20.6888Z"
      stroke="#292D32"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const PlusCircleIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.99935 18.3346C14.5827 18.3346 18.3327 14.5846 18.3327 10.0013C18.3327 5.41797 14.5827 1.66797 9.99935 1.66797C5.41602 1.66797 1.66602 5.41797 1.66602 10.0013C1.66602 14.5846 5.41602 18.3346 9.99935 18.3346Z"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.66602 10H13.3327"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10 13.3346V6.66797"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const PlusCircleBlackIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.99935 18.3346C14.5827 18.3346 18.3327 14.5846 18.3327 10.0013C18.3327 5.41797 14.5827 1.66797 9.99935 1.66797C5.41602 1.66797 1.66602 5.41797 1.66602 10.0013C1.66602 14.5846 5.41602 18.3346 9.99935 18.3346Z"
      stroke="black"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.66602 10H13.3327"
      stroke="black"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10 13.3346V6.66797"
      stroke="black"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const VIPIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.1335 12.6542H4.8668C4.5868 12.6542 4.27347 12.4342 4.18013 12.1676L1.42013 4.44755C1.0268 3.34089 1.4868 3.00089 2.43347 3.68089L5.03347 5.54089C5.4668 5.84089 5.96013 5.68755 6.1468 5.20089L7.32013 2.07422C7.69347 1.07422 8.31347 1.07422 8.6868 2.07422L9.86013 5.20089C10.0468 5.68755 10.5401 5.84089 10.9668 5.54089L13.4068 3.80089C14.4468 3.05422 14.9468 3.43422 14.5201 4.64089L11.8268 12.1809C11.7268 12.4342 11.4135 12.6542 11.1335 12.6542Z"
      stroke="#FF9900"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.33398 14.668H11.6673"
      stroke="#FF9900"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.33398 9.33203H9.66732"
      stroke="#FF9900"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const CameraIcon = () => (
  <svg
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.22945 6.63953C5.65945 4.46953 7.26945 3.51953 9.50945 3.51953H18.2895C20.9295 3.51953 22.6895 4.83953 22.6895 7.91953V13.0695C22.6895 15.2895 21.7795 16.5895 20.2795 17.1495C20.0595 17.2295 19.8195 17.2995 19.5695 17.3395C19.1695 17.4295 18.7395 17.4695 18.2895 17.4695H9.49945C6.85945 17.4695 5.09945 16.1495 5.09945 13.0695V7.91953C5.09945 7.44953 5.13945 7.02953 5.22945 6.63953ZM18.8695 11.9995C18.8695 12.4095 19.2095 12.7495 19.6195 12.7495C20.0295 12.7495 20.3695 12.4095 20.3695 11.9995V8.99953C20.3695 8.58953 20.0295 8.24953 19.6195 8.24953C19.2095 8.24953 18.8695 8.58953 18.8695 8.99953V11.9995ZM13.8995 13.1395C15.3595 13.1395 16.5395 11.9595 16.5395 10.4995C16.5395 9.03953 15.3595 7.85953 13.8995 7.85953C12.4395 7.85953 11.2595 9.03953 11.2595 10.4995C11.2595 11.9595 12.4395 13.1395 13.8995 13.1395ZM7.43945 11.9995C7.43945 12.4095 7.77945 12.7495 8.18945 12.7495C8.59945 12.7495 8.93945 12.4095 8.93945 11.9995V8.99953C8.93945 8.58953 8.59945 8.24953 8.18945 8.24953C7.77945 8.24953 7.43945 8.58953 7.43945 8.99953V11.9995Z"
      fill="#003B0D"
    />
    <path
      d="M2.09965 10.9183V16.0683C2.09965 19.1483 3.85965 20.4783 6.50965 20.4783H15.2896C16.0396 20.4783 16.7096 20.3683 17.2896 20.1483C17.7596 19.9783 18.1696 19.7283 18.4996 19.4083C18.6796 19.2383 18.5396 18.9683 18.2896 18.9683H9.50965C5.80965 18.9683 3.60964 16.7683 3.60964 13.0783V7.91832C3.60964 7.67832 3.33965 7.52832 3.16965 7.70832C2.48965 8.42832 2.09965 9.47832 2.09965 10.9183Z"
      fill="#292D32"
    />
  </svg>
);

const CloseIcon = () => (
  <svg
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.9492 9.05078L9.04972 18.9503"
      stroke="#00050A"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.04972 9.04972L18.9492 18.9492"
      stroke="#00050A"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const CheckIcon = () => (
  <svg
    width="12"
    height="10"
    viewBox="0 0 12 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.04102 5.00088L4.34268 8.30255L10.9577 1.69922"
      stroke="black"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const DownArrowIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.9465 5.45312H7.79316H4.05317C3.41317 5.45312 3.09317 6.22646 3.5465 6.67979L6.99983 10.1331C7.55317 10.6865 8.45317 10.6865 9.0065 10.1331L10.3198 8.81979L12.4598 6.67979C12.9065 6.22646 12.5865 5.45312 11.9465 5.45312Z"
      fill="black"
    />
  </svg>
);



const FacebookSquareIcon = ({
  width = 24,
  height = 24,
  bgColor = "#1877F2",
  color = "white",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.25 0H3.75C1.67893 0 0 1.67893 0 3.75V20.25C0 22.3211 1.67893 24 3.75 24H20.25C22.3211 24 24 22.3211 24 20.25V3.75C24 1.67893 22.3211 0 20.25 0Z"
        fill={bgColor}
      />
      <path
        d="M18 12C18 8.7 15.3 6 12 6C8.7 6 6 8.7 6 12C6 15 8.175 17.475 11.025 17.925V13.725H9.525V12H11.025V10.65C11.025 9.15 11.925 8.325 13.275 8.325C13.95 8.325 14.625 8.475 14.625 8.475V9.975H13.875C13.125 9.975 12.9 10.425 12.9 10.875V12H14.55L14.25 13.725H12.825V18C15.825 17.55 18 15 18 12Z"
        fill={color}
      />
    </svg>
  );
};


const XSquareIcon = ({
  width = 24,
  height = 24,
  bgColor = "#0F1419",
  borderColor = "white",
  color = "white",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.15"
        y="0.15"
        width="23.7"
        height="23.7"
        rx="4.35"
        fill={bgColor}
        stroke={borderColor}
        strokeWidth="0.3"
      />
      <path
        d="M12.8572 11.3113L16.2081 7.5H15.4141L12.5033 10.8086L10.1801 7.5H7.5L11.0139 12.5036L7.5 16.5H8.29393L11.3659 13.0052L13.8199 16.5H16.5L12.8572 11.3113ZM11.7695 12.5476L11.4129 12.049L8.58024 8.08566H9.79988L12.0866 11.2854L12.4417 11.7839L15.4137 15.9429H14.1941L11.7695 12.5476Z"
        fill={color}
      />
    </svg>
  );
};


const InstagramSquareIcon = ({
  width = 24,
  height = 24,
  bgColor = "#F00073",
  color = "white",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="24" height="24" rx="4.35" fill={bgColor} />
      <path
        d="M12.0004 6.90002C13.6504 6.90002 13.8754 6.90002 14.5504 6.90002C15.1504 6.90002 15.4504 7.05002 15.6754 7.12502C15.9754 7.27502 16.2004 7.35002 16.4254 7.57502C16.6504 7.80002 16.8004 8.02502 16.8754 8.32502C16.9504 8.55002 17.0254 8.85002 17.1004 9.45002C17.1004 10.125 17.1004 10.275 17.1004 12C17.1004 13.725 17.1004 13.875 17.1004 14.55C17.1004 15.15 16.9504 15.45 16.8754 15.675C16.7254 15.975 16.6504 16.2 16.4254 16.425C16.2004 16.65 15.9754 16.8 15.6754 16.875C15.4504 16.95 15.1504 17.025 14.5504 17.1C13.8754 17.1 13.7254 17.1 12.0004 17.1C10.2754 17.1 10.1254 17.1 9.45039 17.1C8.85039 17.1 8.55039 16.95 8.32539 16.875C8.02539 16.725 7.80039 16.65 7.57539 16.425C7.35039 16.2 7.20039 15.975 7.12539 15.675C7.05039 15.45 6.97539 15.15 6.90039 14.55C6.90039 13.875 6.90039 13.725 6.90039 12C6.90039 10.275 6.90039 10.125 6.90039 9.45002C6.90039 8.85002 7.05039 8.55002 7.12539 8.32502C7.27539 8.02502 7.35039 7.80002 7.57539 7.57502C7.80039 7.35002 8.02539 7.20002 8.32539 7.12502C8.55039 7.05002 8.85039 6.97502 9.45039 6.90002C10.1254 6.90002 10.3504 6.90002 12.0004 6.90002Z"
        fill={color}
      />
      <path
        d="M12.0004 8.77502C10.2004 8.77502 8.77539 10.2 8.77539 12C8.77539 13.8 10.2004 15.225 12.0004 15.225C13.8004 15.225 15.2254 13.8 15.2254 12C15.2254 10.2 13.8004 8.77502 12.0004 8.77502Z"
        fill={color}
      />
      <path
        d="M15.3004 9.45002C15.7146 9.45002 16.0504 9.11424 16.0504 8.70002C16.0504 8.28581 15.7146 7.95002 15.3004 7.95002C14.8862 7.95002 14.5504 8.28581 14.5504 8.70002C14.5504 9.11424 14.8862 9.45002 15.3004 9.45002Z"
        fill={color}
      />
    </svg>
  );
};


const LinkedinSquareIcon = ({
  width = 24,
  height = 24,
  bgColor = "#2867B2",
  color = "white",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="24" height="24" rx="4" fill={bgColor} />
      <path
        d="M8.7 18H6.15V9.975H8.7V18ZM7.425 8.85C6.6 8.85 6 8.25 6 7.425C6 6.6 6.675 6 7.425 6C8.25 6 8.85 6.6 8.85 7.425C8.85 8.25 8.25 8.85 7.425 8.85ZM18 18H15.45V13.65C15.45 12.375 14.925 12 14.175 12C13.425 12 12.675 12.6 12.675 13.725V18H10.125V9.975H12.525V11.1C12.75 10.575 13.65 9.75 14.925 9.75C16.35 9.75 17.85 10.575 17.85 13.05V18H18Z"
        fill={color}
      />
    </svg>
  );
};

  const PhoneIcon = () => (
    <svg
      width="14"
      height="14"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"
        fill="currentColor"
      />
    </svg>
  );

  const RsvpIcon = () => (
    <svg
      width="14"
      height="14"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
        fill="currentColor"
      />
    </svg>
  );

  const DropdownArrowIcon = () => (
    <svg
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M7 10l5 5 5-5z" fill="currentColor" />
    </svg>
  );



  const TicketIcon = () => (
    <svg
      width="80"
      height="80"
      viewBox="0 0 80 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="10" y="25" width="60" height="30" rx="4" fill="#F5A623" />
      <line
        x1="40"
        y1="28"
        x2="40"
        y2="52"
        stroke="white"
        strokeWidth="3"
        strokeDasharray="4 4"
      />
      <circle cx="40" cy="30" r="3" fill="white" />
      <circle cx="40" cy="50" r="3" fill="white" />
    </svg>
  );

  const AttireIcon = () => (
    <svg
      width="80"
      height="80"
      viewBox="0 0 80 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M40 20L50 30H30L40 20Z" fill="#9C27B0" />
      <rect x="30" y="30" width="20" height="35" rx="2" fill="#9C27B0" />
      <rect x="25" y="35" width="5" height="25" rx="1" fill="#9C27B0" />
      <rect x="50" y="35" width="5" height="25" rx="1" fill="#9C27B0" />
    </svg>
  );

  const GiftIcon = () => (
    <svg
      width="80"
      height="80"
      viewBox="0 0 80 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="20" y="35" width="40" height="25" rx="2" fill="#4CAF50" />
      <rect x="25" y="30" width="30" height="5" rx="1" fill="#66BB6A" />
      <path d="M40 30V60" stroke="white" strokeWidth="3" />
      <path
        d="M35 25C35 22 37 20 40 20C43 20 45 22 45 25C45 27 43 30 40 30"
        fill="#66BB6A"
      />
      <path
        d="M45 25C45 22 43 20 40 20C37 20 35 22 35 25C35 27 37 30 40 30"
        fill="#66BB6A"
      />
    </svg>
  );







export {
  NotificationIcon,
  SecureHomeIcon,
  CalendarIcon,
  UsersGroupIcon,
  SecureCameraIcon,
  UserProfileCircleIcon,
  BellNotificationIcon,
  BookOpenQuestionIcon,
  ArrowRightRedIcon,
  LockShieldIcon,
  CashIcon,
  NotificationBellIcon,
  SendIcon,
  ClockIcon,
  ShieldCheckIcon,
  SearchIcon,
  SearchZoomIcon,
  PlusCircleIcon,
  PlusCircleBlackIcon,
  VIPIcon,
  CameraIcon,
  CloseIcon,
  CheckIcon,
  DownArrowIcon,
  FacebookSquareIcon,
  XSquareIcon,
  InstagramSquareIcon,
  LinkedinSquareIcon,
  PhoneIcon,
  RsvpIcon,
  DropdownArrowIcon,
  TicketIcon,
  AttireIcon,
  GiftIcon,
};
